import { SupportedCurrencyCode } from '../Types/generated-types'

export const isCurrency = (currency?: string | null): currency is SupportedCurrencyCode =>
  !!currency && currency in SupportedCurrencyCode
